// 
var links = document.links;
for (let i = 0, linksLength = links.length; i < linksLength; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}

// dom content loaded
document.addEventListener('DOMContentLoaded', function () {
  appstleInit();
});

customElements.define('abz-featured-appstle-widget', class extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.oneTimeContainer = document.getElementById('appstle-one-time-container');
    this.oneTimeContainer.addEventListener('click', () => {
      let input = this.querySelector('.appstle_onetime_block > [name="selling_plan"]');
      input && (input.checked = true) ;
      input && input.dispatchEvent(new Event('change'));
    })
  }

  appendOneTimeInput() {
    if (this.getAttribute('data-moved-onetime') === 'true') return;
    this.oneTimeInput = this.querySelector('.appstle_input_wrapper.appstle_onetime_block');
    if (this.oneTimeInput) {
      this.oneTimeContainer.prepend(this.oneTimeInput);
      this.setAttribute('data-moved-onetime', 'true');
    }
  }
});

document.addEventListener('AppstleSubscription:SubscriptionWidget:SellingPlanSelected', function (e) {
  console.log('subscription created', e);
  // Do your custom actions here
  document.querySelectorAll('abz-featured-appstle-widget').forEach(widget => widget.appendOneTimeInput());
});



// aelami-shop
$('.aelami-shop').owlCarousel({
  margin: 15,
  loop: true,
  nav: false,
  autoplay: true,
  autoplayTimeout: 1000,
  dots: false,
  autoWidth: true,
  smartSpeed: 500,
  responsive: {
    0: {
      items: 2
    },
    600: {
      items: 3
    },
    768: {
      items: 4
    },
    1000: {
      items: 5
    },
    1280: {
      items: 6
    },
    1366: {
      items: 7
    },
    1536: {
      items: 8
    }
  }
})


// Featured tab
var owl = $('.Testimonials').owlCarousel({
  loop: true,
  nav: false,
  margin: 20,
  dots: false,
  autoplay: true,
  smartSpeed: 500,
  responsive: {
    0: {
      items: 1
    },
    567: {
      items: 1
    },
    1000: {
      items: 3
    }
  }
})


// Smooth auto scroll slider for each instance
document.addEventListener('DOMContentLoaded', function () {
  // Select all elements with a dynamic ID that matches 'smoothscroll-{section.id}'
  document.querySelectorAll('[id^="smoothscroll"]').forEach(function (slider) {
    new Splide(slider, {
      type: 'loop',
      drag: 'free',
      focus: 'center',
      direction: slider.getAttribute('data-direction'),
      arrows: false,
      autoWidth: true,
      pagination: false,
      perPage: 4,
      autoScroll: {
        speed: 0,
      },
    }).mount(window.splide.Extensions);
  });
});

// Go back
function goBack() {
  window.history.back(); 
}

// Font style
document.addEventListener("DOMContentLoaded", function () {
  // Find element containing that exact title
  const elements = document.querySelectorAll("*:not(script):not(style)");

  elements.forEach(function (el) {
    if (
      el.childNodes.length === 1 &&
      el.textContent.includes("Team Us vs. Team Everyone Else!")
    ) {
      // Replace "vs" with span + line break
      el.innerHTML = el.innerHTML.replace(
        "vs.",
        '<span style="font-weight: normal;">vs.</span><br>'
      );
    }
  });
});

// smooth scroll
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('a[href="#smooth-offers"]').forEach(link => {
    link.addEventListener("click", function (e) {
      e.preventDefault();
      const target = document.getElementById("smooth-offers");
      if (target) {
        const top = target.getBoundingClientRect().top + window.scrollY - 60;
        window.scrollTo({
          top: top,
          behavior: "smooth"
        });
      }
    });
  });
});
